import script from "./ActionNeeded2.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionNeeded2.vue?vue&type=script&setup=true&lang=js"

import "./ActionNeeded2.vue?vue&type=style&index=0&id=e13934d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e13934d4"]])

export default __exports__